<vc-privacy-policy-banner [privacySettings]="privacySettings"> </vc-privacy-policy-banner>
